import L from "leaflet";

export default L.icon({
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
  iconUrl: "//unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
  shadowUrl: "//unpkg.com/leaflet@1.6/dist/images/marker-shadow.png"
});